(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/league-ahl/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/themes/league-ahl/assets/javascripts/init.js'); 
var svs = svs || {};

(function(svs, _) {
  svs.themes = svs.themes || {};
  svs.themes.league_ahl = svs.themes.league_ahl || {};

  var log = new svs.core.log.Logger('svs.themes.league_ahl.init');

  svs.themes.league_ahl.init = function(func, params) {
    if (!_.isArray(params)) {
      params = [params];
    }

    if (typeof svs.themes.league_ahl[func] === 'function') {
      return svs.themes.league_ahl[func].apply(svs.themes.league_ahl, params);
    }
    log.debug('function ' + func + ' does not exist in this theme');
  };
})(svs, _);

 })(window);